import ApiService from '@/services/api.service'

const PharmacyOptionService = {

    getAll() {          
        const requestData = {
            method: 'get',
            url: "/PharmacyOptions",
            headers: {
                
              },
            params: { 
               
            }
        }
        return ApiService.customRequest(requestData);
    },    

    getPharmacyOptions(){
        return ApiService.get(`/PharmacyOptions`);
    },

    add(data){
        return ApiService.post(`/PharmacyOptions`, data);
    },

    update(Id,data){
        return ApiService.put(`/PharmacyOptions/${Id}`,data);
    },

}
  
  export default PharmacyOptionService;